import { useMemo } from "react"
import { usePublicContact } from "../context/usePublicContactContext"
import { SITE_URL } from "./seoConfig"

export const useOrganizationSchema = () => {
  const { contact } = usePublicContact()

  return useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mestre da Comanda",
      url: SITE_URL,
      logo: `${SITE_URL}/../../src/assets/images/Logo2.png`,
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: contact.email ?? undefined,
        telephone: contact.whatsAppPhone ? `+${contact.whatsAppPhone}` : undefined,
        areaServed: "BR",
        availableLanguage: ["Portuguese"],
      },
    }),
    [contact.email, contact.whatsAppPhone],
  )
}

export const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Mestre da Comanda",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  offers: { "@type": "Offer", price: "0", priceCurrency: "BRL" },
  description:
    "Software para restaurante SaaS com PDV, sistema de pedidos online, comanda digital, emissão de cupom fiscal (NFC-e), controle de rodízio e gestão de delivery.",
}

export const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Mestre da Comanda SaaS para Restaurantes",
  brand: "Mestre da Comanda",
  description:
    "Sistema de gestão para restaurante com PDV, cardápio digital, comanda, emissão de cupom fiscal, controle de rodízio, delivery e operação local.",
}

export const supportFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Como funciona o sistema de pedidos online do Mestre da Comanda?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "O Mestre da Comanda centraliza pedidos online, cardápio digital, pagamentos e gestão de cozinha em uma única plataforma.",
      },
    },
    {
      "@type": "Question",
      name: "O Mestre da Comanda atende delivery e restaurantes locais?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim. O software para restaurante permite operação local, retirada e entrega com controle unificado.",
      },
    },
    {
      "@type": "Question",
      name: "O Mestre da Comanda funciona como PDV e emite cupom fiscal?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim. O sistema funciona como PDV para restaurante, com frente de caixa integrada à comanda e emissão de cupom fiscal (NFC-e) direto no fechamento do pedido.",
      },
    },
    {
      "@type": "Question",
      name: "O Mestre da Comanda tem suporte a rodízio?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim. O sistema conta com módulo de rodízio, permitindo controlar sessões, planos e consumo por mesa em restaurantes que trabalham com rodízio de carnes, pizza ou sushi.",
      },
    },
  ],
}

export const buildRestaurantSchema = (name: string, path: string, description?: string, image?: string) => ({
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name,
  description,
  url: `${SITE_URL}${path}`,
  image: image
    ? image.startsWith("http")
      ? image
      : `${SITE_URL}${image}`
    : `${SITE_URL}/../../src/assets/images/Logo2.png`,
})
